import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from 'i18next-browser-languagedetector';

// Importing translations
import transration_en from "./en.json";
import transration_ja from "./ja.json";

const resources = {
    eng: {
        translation: transration_en,
    },
    member: {
        translation: transration_ja,
    },
    ja: {
        translation: transration_ja,
    },
    };

i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources,
        fallbackLng: "member",
        interpolation: {
            escapeValue: false,
        },
        detection: {
          order: ['path', 'cookie', 'localStorage', 'navigator'],
          lookupFromPathIndex: window.location.hostname === 'test4.sociohealth.jp' ? 1 : 0,
          checkWhitelist: true
        },
        supportedLngs : ['eng', 'member', 'ja'],
    });

export default i18n;